import { styled } from "@mui/system";
import { Paper } from "@mui/material";

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: 16,
  boxShadow: theme.shadows[6],
  paddingBottom: "20px",
  paddingTop: "10px",
}));

export default StyledPaper;
